module.exports = __webpack_public_path__ + "static/media/issue-white.b0620050.svg";